module.exports = __webpack_public_path__ + "img/img_1_style.c1b0ad52.png";